export default __webpack_public_path__ + "static/media/V420_SOV.e2a83c57.pdf";